import React from 'react';
import './hero.css';
import { Message } from './../lib/getMessage';

export default ({ scrollTo }) => (
  <div className="hero" style={{ width: '100%', height: 'auto' }}>
    <div className="wrap">
      <div className="information">
        <h2>
          <Message dictKey="hero.zopsmart.technology" />
        </h2>
        <hr />
        <p>
          <strong>
            <Message dictKey="hero.zopsmart.technology.content.bold" />
          </strong>
        </p>
        <br></br>
        <p>
          <Message dictKey="hero.zopsmart.technology.content.para1" />
        </p>
        <br></br>
        <p>
          <Message dictKey="hero.zopsmart.technology.content.para2" />
        </p>
        <br></br>
        <p>
          <Message dictKey="hero.zopsmart.technology.content.para3" />
        </p>
        <br></br>
        <p>
          <strong>
            <Message dictKey="hero.zopsmart.technology.content.para4" />
          </strong>
        </p>
      </div>
    </div>
  </div>
);
